/**
 * Irmão: `src/app/components/filters/optionUtils.ts`.
 *
 * Duplicação deliberada (openspec/changes/flashcards-revisao-redesign/design.md,
 * Decisão 2). Não reusar `components/filters/`: store, persistência e efeito de
 * aplicação são de outra tela. Uma correção visual aqui deve ser conferida
 * no irmão, e o inverso.
 */

/** Accent- and case-insensitive comparison, so "materia" finds "Matéria". */
export function revisaoNormalizeText(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function revisaoMatchesQuery(option: string, query: string): boolean {
  const needle = revisaoNormalizeText(query);
  if (needle === "") return true;
  return revisaoNormalizeText(option).includes(needle);
}

/**
 * Chosen options come first.
 *
 * A section shows only its first twelve options, so without this a selection
 * made through the search box or the full-list dialog could sit outside the
 * visible window — the user would see no evidence of their own choice.
 */
export function revisaoOrderBySelection(options: string[], selected: string[]): string[] {
  if (selected.length === 0) return options;
  const chosen = new Set(selected);
  const front: string[] = [];
  const rest: string[] = [];
  options.forEach((option) => (chosen.has(option) ? front : rest).push(option));
  return front.concat(rest);
}
